import { AppView } from "./AppView";
import { useAppController } from "./useAppController";

export function App() {
  const controller = useAppController();
  return <AppView {...controller} />;
}
